var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.59 450.704h-257.242c-11.046 0-20-8.954-20-20v-369.346h-33.148c-12.103 0-21.914 9.811-21.914 21.914v391.815c0 12.102 9.811 21.913 21.914 21.913h288.477c12.103 0 21.914-9.811 21.914-21.914v-24.382z",
    fill: "#8ac9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.348 61.358v369.346c0 11.046 8.954 20 20 20h257.242v24.383c0 4.268-1.225 8.249-3.336 11.617h-271.992c-12.102 0-21.913-9.811-21.913-21.914v-16l10-375.815z",
    fill: "#60b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.652 415.642h-257.242c-11.046 0-20-8.954-20-20v-360.58h-33.148c-12.102 0-21.913 9.811-21.913 21.914v391.814c0 12.103 9.811 21.914 21.913 21.914h288.477c12.103 0 21.914-9.811 21.914-21.914v-33.148z",
    fill: "#fed402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.41 35.062v360.58c0 11.046 8.954 20 20 20h257.242v33.148c0 1.784-.218 3.515-.62 5.175h-274.709c-12.102 0-21.913-9.811-21.913-21.914v-18.323l10-27.665v-345.826z",
    fill: "#fac600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.8 435.642h-286.477c-12.102 0-21.913-9.811-21.913-21.914v-391.814c0-12.103 9.811-21.914 21.913-21.914h221.616l86.774 88.774v324.954c.001 12.103-9.81 21.914-21.913 21.914z",
    fill: "#efedef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.714 58.774v354.954c0 12.103-9.811 21.914-21.913 21.914h30c12.103 0 21.913-9.811 21.913-21.914v-324.954z",
    fill: "#d7d0d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.714 88.774h-66.864c-12.1 0-21.91-9.809-21.91-21.91v-66.864z",
    fill: "#b5adb6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m383.64 169.733h-200.156c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h200.156c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#b5adb6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m383.64 225.321h-200.156c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h200.156c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#b5adb6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m383.64 280.909h-200.156c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h200.156c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#b5adb6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.f03792adca73bec010e96b2131c59115.svg";
export { ForwardRef as ReactComponent };